import ModelYearRangeTapEvent from 'lib/Tracking/Srp/SearchFilters/ModelYearRangeTap';
import { useYearFilter } from 'lib/hooks/useSrpFilters';
import useEvents from 'lib/hooks/useEvents';

import InputSliderBlock, {
  InputSliderBlockValue,
} from 'components/Shared/SearchFilter/InputSliderBlock';

export default function ModelYearInputSliderBlock(): JSX.Element {
  const logger = useEvents();
  const { value, setValue } = useYearFilter();

  const onChange = (val: InputSliderBlockValue): void => {
    setValue(val);
    logger.log(ModelYearRangeTapEvent());
  };

  const maxModelYear: number = new Date().getFullYear() + 1;

  return (
    <InputSliderBlock
      onChange={onChange}
      minAllowed={1940}
      maxAllowed={maxModelYear}
      initialMin={value.min}
      initialMax={value.max}
      minPlaceholder={'Pre 1940'}
      maxPlaceholder={maxModelYear.toString()}
      pushable={false}
      step={1}
      hasThousandSeparator={false}
      getMinPrefix={({ isFocused, numericValue }): string | undefined => {
        if (isFocused) {
          return undefined;
        }
        return numericValue && numericValue <= 1940 ? 'Pre ' : undefined;
      }}
    />
  );
}
